export const getSizeClasses = (size) => {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  }
  return sizeClasses[size] || sizeClasses.md
}

export const getGoogleVariantClasses = (variant) => {
  const variantClasses = {
    primary: 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
    secondary: 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200',
    outline: 'bg-transparent text-gray-700 border-gray-300 hover:bg-gray-50'
  }
  return variantClasses[variant] || variantClasses.primary
}

export const getAppleVariantClasses = (variant) => {
  const variantClasses = {
    dark: 'bg-black text-white border-black hover:bg-gray-800',
    light: 'bg-white text-black border-gray-300 hover:bg-gray-50'
  }
  return variantClasses[variant] || variantClasses.dark
}

export const getBaseButtonClasses = (size, variantClasses, className, disabled, isLoading) => {
  return `
    inline-flex items-center justify-center gap-3
    border rounded-xl font-medium transition-all duration-200
    ${getSizeClasses(size)} ${variantClasses} ${className}
    ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-lg hover:scale-105 active:scale-95'}
  `
}

export const getGoogleButtonStyles = () => ({
  minWidth: '240px',
  backdropFilter: 'blur(10px)',
  background: 'rgba(255, 255, 255, 0.9)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
})

export const getAppleButtonStyles = () => ({
  minWidth: '240px',
  backdropFilter: 'blur(10px)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
})

export const getDiscordVariantClasses = (variant) => {
  const variantClasses = {
    primary: 'bg-[#5865F2] text-white border-[#5865F2] hover:bg-[#4752C4]',
    secondary: 'bg-[#4752C4] text-white border-[#4752C4] hover:bg-[#3C45A5]',
    outline: 'bg-transparent text-[#5865F2] border-[#5865F2] hover:bg-[#5865F2]/10'
  }
  return variantClasses[variant] || variantClasses.primary
}

export const getDiscordButtonStyles = () => ({
  minWidth: '240px',
  backdropFilter: 'blur(10px)',
  boxShadow: '0 8px 32px rgba(88, 101, 242, 0.2)'
})

export const getFacebookVariantClasses = (variant) => {
  const variantClasses = {
    primary: 'bg-[#1877F2] text-white border-[#1877F2] hover:bg-[#166FE5]',
    secondary: 'bg-[#166FE5] text-white border-[#166FE5] hover:bg-[#1467D6]',
    outline: 'bg-transparent text-[#1877F2] border-[#1877F2] hover:bg-[#1877F2]/10'
  }
  return variantClasses[variant] || variantClasses.primary
}

export const getFacebookButtonStyles = () => ({
  minWidth: '240px',
  backdropFilter: 'blur(10px)',
  boxShadow: '0 8px 32px rgba(24, 119, 242, 0.2)'
})

export const getMicrosoftVariantClasses = (variant) => {
  const variantClasses = {
    primary: 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
    secondary: 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200',
    outline: 'bg-transparent text-gray-700 border-gray-300 hover:bg-gray-50'
  }
  return variantClasses[variant] || variantClasses.primary
}

export const getMicrosoftButtonStyles = () => ({
  minWidth: '240px',
  backdropFilter: 'blur(10px)',
  background: 'rgba(255, 255, 255, 0.9)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
})